<template>
    <boolean-setting v-if="isBoolean(setting)" v-model="setting" />
    <number-setting v-if="isNumber(setting)" v-model="setting" />
    <date-setting v-if="isDate(setting)" v-model="setting" />
    <string-setting v-if="isString(setting)" v-model="setting" :validator="validator" />
    <account-setting v-if="isAccountCheck(setting)" v-model="setting" />
    <bank-account-setting v-if="isBankAccountCheck(setting)" v-model="setting" />
</template>
<script setup lang="ts">
// TODO: The "knowledge" of domain and type should be changed around. Eg. bank-account-settings should know it is of type Setting, but Setting does not need to know that there exists a BankAccountSetting
import {Setting, SettingName, useSetting} from '@/setting/setting.service'
import BooleanSetting from '@/setting/BooleanSetting.vue'
import {SettingValidator} from '@/setting/SettingValidator'
import {PropType} from 'vue'
import NumberSetting from '@/setting/NumberSetting.vue'
import DateSetting from '@/setting/DateSetting.vue'
import StringSetting from '@/setting/StringSetting.vue'
import AccountSetting from '@/setting/AccountSetting.vue'
import BankAccountSetting from '@/setting/BankAccountSetting.vue'

const props = defineProps(
    {
        name: {
            required: true,
            type: Object as PropType<SettingName>
        },
        isAccount: {
            type: Boolean,
            default: false
        },
        isBankAccount: {
            type: Boolean,
            default: false
        },
        validator: {
            type: Function as PropType<SettingValidator>,
            required: false
        }
    }
)

const {setting} = useSetting<any>(props.name)

const isBoolean = (setting: Setting<any> | undefined): setting is Setting<boolean> => {
    if (setting === undefined) {
        return false
    }
    return setting.type === 'boolean'
}

const isNumber = (setting: Setting<any> | undefined): setting is Setting<number> => {
    if (setting === undefined) {
        return false
    }
    return setting.type === 'number'
}

const isDate = (setting: Setting<any> | undefined): setting is Setting<Date> => {
    if (setting === undefined) {
        return false
    }
    return setting.type === 'date'
}

const isString = (setting: Setting<any> | undefined): setting is Setting<string> => {
    if (setting === undefined) {
        return false
    }
    return !props.isAccount && !props.isBankAccount && setting.type === 'string'
}

const isAccountCheck = (setting: Setting<any> | undefined): setting is Setting<string> => {
    if (setting === undefined) {
        return false
    }
    return props.isAccount && setting.type === 'string'
}

//TODO: too domain specific, does not belong in a generic settings component
const isBankAccountCheck = (setting: Setting<any> | undefined): setting is Setting<string> => {
    if (setting === undefined) {
        return false
    }
    return props.isBankAccount && setting.type === 'string'
}

</script>

<style scoped>

</style>